import React,{useState} from 'react' 
import {motion} from 'framer-motion'
import './Two.css'
import img1 from '../assets/img1.png' 
import img2 from '../assets/img2.png' 
import img3 from '../assets/img3.png'
import divi from '../assets/divi.svg' 

const imgBoxVariants = {
  hidden:{
    x:100,
    opacity: 0
  },
  visible:{
    x: 0,
    opacity: 1,
    transition:{
      delay: 0.5, duration: 0.5
    }
  }
}



export const SliderAboutBookReview = () => { 

  const [step, setStep] = useState(1);

  const handleLeftArrow=()=>{
    if(step===1){
      setStep(3);
    }
    else{
    setStep(step-1);
    }
  }

  const handleRightArrow=()=>{
    if(step===3){
      setStep(1);
    }
    else{
      setStep(step+1);
    }
  }

  const goToSlide1=()=>{
    setStep(1);
  }

  const goToSlide2=()=>{
    setStep(2);
  }

  const goToSlide3=()=>{
    setStep(3);
  }

  return (
    <> 

<div className='wrapper w-[100%]  '>

                 

<div className='content flex justify-center'>

  

 {step===1&&<motion.div className='img-box' variants={imgBoxVariants}
 initial="hidden" animate="visible">

 <div className=' '>
<div className='  border-4 my-4 border-gray-200 rounded-xl pt-7 pb-16 px-6'>
    <div className=''>
        <form className='  mx-auto'>

            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

        </form>
        <h1 className='text-[18px] text-[#272C34] font-bold'>Perfect court management</h1>
    </div>
    <div>
        <p className='text-[#272C34]  pt-5 text-xs'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Vestibulum nunc metus, mattis quis nibh eget, vulputate ultrices est.
    Cras ipsum sapien, malesuada nec sagittis id, convallis quis purus.
    Cras faucibus risus gravida libero vestibulum, nec viverra risus ultricies.</p>
    </div>
    <div className='float-right w-[150px] flex '>
    <span className='border border-[#6A7D95] h-[2px] w-6 mt-7 mx-1'></span>
        <p className='text-[#6A7D95]  italic pt-5 text-sm '> Alan Smith </p>
    </div>
</div>
</div>

           
 </motion.div>}

 {step===2&&<motion.div className='img-box' variants={imgBoxVariants}
 initial="hidden" animate="visible">
  <div className=' w-[100%]'>
<div className='  border-4 my-4 border-gray-200 rounded-xl  pt-7 pb-16 px-6'>
    <div className=''>
        <form className=' mx-auto'>

            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

        </form>
        <h1 className='text-[18px] text-[#272C34] font-bold'>Perfect court management</h1>
    </div>
    <div>
        <p className='text-[#272C34]  pt-5 text-xs'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Vestibulum nunc metus, mattis quis nibh eget, vulputate ultrices est.
    Cras ipsum sapien, malesuada nec sagittis id, convallis quis purus.
    Cras faucibus risus gravida libero vestibulum, nec viverra risus ultricies.</p>
    </div>
    <div className='float-right w-[150px] flex'>
    <span className='border border-[#6A7D95] h-[2px] w-6 mt-7 mx-1'></span>
        <p className='text-[#6A7D95]  italic pt-5 text-sm'> Jennifer </p>
    </div>
</div>
</div>        
 </motion.div>}

 {step===3&&<motion.div className='img-box' variants={imgBoxVariants}
 initial="hidden" animate="visible">
  <div className=' w-[100%]'>
<div className='  border-4 my-4 border-gray-200 rounded-xl  pt-7 pb-16 px-6'>
    <div className=''>
        <form className=' mx-auto'>

            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
            <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

        </form>
        <h1 className='text-[18px] text-[#272C34] font-bold'>Perfect court management</h1>
    </div>
    <div>
        <p className='text-[#272C34]  pt-5 text-xs'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Vestibulum nunc metus, mattis quis nibh eget, vulputate ultrices est.
    Cras ipsum sapien, malesuada nec sagittis id, convallis quis purus.
    Cras faucibus risus gravida libero vestibulum, nec viverra risus ultricies.</p>
    </div>
    <div className='float-right w-[150px] flex'>
    <span className='border border-[#6A7D95] h-[2px] w-6 mt-7 mx-1'></span>
        <p className='text-[#6A7D95]  italic pt-5 text-sm'>  John Doe</p>
    </div>
</div>
</div>        
 </motion.div>}

 

</div>

<div className='indi flex items-center p-2 mt-3'>

<div className='left-arrow flex hidden md:inline-block px-6 py-5' onClick={handleLeftArrow}>
  <i class="fa-solid fa-angle-left"></i>
  </div>

    {step===1&&<><div className='indicator cursor-pointer active p-3'><img src={img1} alt='imgrs' className='w-full' /></div>
    <div className='indicator cursor-pointer p-3' onClick={goToSlide2}><img src={img1} alt='imgrs'className='w-full'  /></div>
    <div className='indicator cursor-pointer p-3' onClick={goToSlide3}><img src={img2} alt='imgrs' className='w-full' /></div></>}

    {step===2&&<><div className='indicator cursor-pointer p-3' onClick={goToSlide1}><img src={img1} alt='imgrs' className='w-full' /></div>
    <div className='indicator cursor-pointer active p-3'> <img src={img2} alt='imgrs' className='w-full' /> </div>
    <div className='indicator cursor-pointer p-3' onClick={goToSlide3}> <img src={img3} alt='imgrs' className='w-full' /> </div></>}

    {step===3&&<><div className='indicator cursor-pointer p-3' onClick={goToSlide1}><img src={img1} alt='imgrs' className='w-full' /></div>
    <div className='indicator cursor-pointer p-3' onClick={goToSlide2}><img src={img3} alt='imgrs' className='w-full'  /></div>
    <div className='indicator cursor-pointer active p-3'><img src={img1} alt='imgrs' className='w-full' /></div></>}

    <div>
      <h2 className='text-xs'>+15</h2>
    </div>

     <div className='right-arrow flex hidden md:inline-block px-6 py-5' onClick={handleRightArrow}>
  <i class="fa-solid fa-angle-right"  ></i>
   
  </div>

</div>

</div>
</>

)
}

